<template lang="pug">
v-data-table.elevation-1(:headers='headers' :items='productosEnCarrito' sort-by='calories')
      template(v-slot:top)
        v-toolbar(flat dense color='primary' dark)
          v-toolbar-title.justify-center(color='success') Productos Cargados
          v-divider.mx-4(inset vertical)
          v-spacer
          v-dialog(v-model='dialog' scrollable persistent max-width='50%')
            v-card(color='grey_1')
              v-app-bar(dark color='primary')
                v-toolbar-title.headline {{ formTitle }}
              v-divider(light)
              v-card-text
                v-row(dense)
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-text
                        v-row(dense)
                          v-col(cols='12' sm='12' md='6')
                            v-text-field(dense outlined readonly v-model='editedItem.idProducto.nombre' label='Producto')
                          v-col(cols='12' sm='12' md='6')
                            v-text-field(dense outlined type='number' v-model='editedItem.cantidadSolicitadaAux' label='Cantidad del Producto')
                          v-col(cols='12' sm='12' md='6')
                          v-col(cols='12' sm='12' md='6')
                            v-text-field(dense outlined readonly :value='editedItem.total | read' label='Total')
              v-card-actions
                v-spacer
                v-btn(color='error' small dark @click.native='close')
                  v-icon mdi-close
                  | Cancelar
                v-btn(color='success' small dark @click.native='save')
                  v-icon mdi-content-save
                  | Guardar
      template(v-if="!read" v-slot:item.action='{ item }')
        v-icon.mr-2(color='warning' @click='editItem(item)') mdi-pencil
        v-icon(color='error' @click='quitarCarrito(item)') mdi-delete
      template(v-slot:no-data='')
        h2.pa-2 No existen productos cargados
</template>

<script>
export default {
  props: ['productosEnCarrito', 'read'],
  data: () => ({
    dialog: false,
    headers: [
      { text: 'Cod. Producto', value: 'idProducto.nombre', align: 'center'},
      { text: 'Nom. Producto', value: 'idProducto.descripcion', align: 'center'},
      { text: 'Cantidad', value: 'cantidadSolicitada', sortable: false, align: 'center'},
      //{ text: 'Unidad Medida', value: 'idProducto.unidadMedida.descripcion', sortable: false },
      { text: "Costo(Bs)", value: "costo", sortable: false },
      { text: 'Precio(Bs)', value: 'precioBs', sortable: false, align: 'center'},
      { text: 'Precio($)', value: 'precio', sortable: false, align: 'center'},
      { text: 'SubTotal', value: 'subTotal', sortable: false, align: 'center'},
      // { text: "Base Imponible", value: "baseImponible", sortable: false },
      // { text: "Gravado", value: "gravado", sortable: false },
      // { text: "Exento", value: "exento", sortable: false },
      { text: 'IVA(%)', value: 'idIva.descripcion', sortable: false, align: 'center'},
      { text: 'Total', value: 'total', sortable: false, align: 'center'},
      { text: 'Acciones', value: 'action', sortable: false, align: 'center'}
    ],
    productos: [],
    idProductosArray: [],
    editedIndex: -1,
    editedItem: {
      idProducto: '',
      unidadMedida: '',
      costo: 0,
      precioBs: 0,
      cantidad: 0,
      cantidadSolicitada: 0,
      cantidadSolicitadaAux: 0,
      subTotal: 0,
      baseImponible: 0,
      idIva: '',
      gravado: 0,
      exento: 0,
      total: 0
    },
    defaultItem: {
      idProducto: '',
      unidadMedida: '',
      costo: 0,
      precioBs: 0,
      cantidad: 0,
      cantidadSolicitada: 0,
      cantidadSolicitadaAux: 0,
      subTotal: 0,
      baseImponible: 0,
      idIva: '',
      gravado: 0,
      exento: 0,
      total: 0
    }
  }),
  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Cargar Producto al Pedido'
        : 'Editar Producto del pedido'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },

    'editedItem.cantidadSolicitadaAux': function (val) {
      if (parseInt(val) > 0) {
        this.editedItem.subTotal = Math.round((parseInt(val) * this.editedItem.precioBs) * 100) / 100
        this.actualizarPrecios()
      }
    }
  },

  methods: {
    actualizarPrecios () {
      if (this.editedItem.idIva.valor > 0) {
        // Producto con IVA
        this.editedItem.gravado = Math.round((this.editedItem.subTotal * this.editedItem.idIva.valor) * 100) / 100
        this.editedItem.exento = 0
        this.editedItem.total =
        Math.round((this.editedItem.gravado + this.editedItem.subTotal) * 100) / 100
        this.editedItem.baseImponible = this.editedItem.subTotal
      } else {
        // Producto sin IVA
        this.editedItem.gravado = 0
        this.editedItem.baseImponible = 0
        this.editedItem.exento = this.editedItem.subTotal
        this.editedItem.total = this.editedItem.exento
      }
    },

    validarCantidad () {
      if (this.editedItem.cantidadSolicitadad <= 0) {
        this.$swal({
          icon: 'error',
          title: 'No ha cargado ningun producto',
          text: 'La cantidad ingresada debe ser mayor que 0 para procesar el pedido'
        })
        return true
      }
      return false
    },

    editItem (item) {
      this.editedIndex = this.productosEnCarrito.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.productosEnCarrito.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres borrar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.productosEnCarrito.splice(index, 1)
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    quitarCarrito (item) {
      this.$emit('quitarCarrito', item)
    },

    save () {
      this.editedItem.cantidadSolicitadaAux = parseInt(this.editedItem.cantidadSolicitadaAux)
      this.$emit('modificarCarrito', this.editedItem)
      this.close()
    }
  }
}
</script>
